// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t2SF","label":"styles_label__3OF4k"};